// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Spinner from '../loaders/Spinner';

// Styles
import './PopupEmptyContent.scss';

const PopupEmptyContent = ({ className, message, children, showSpinner }) => {
    const messageComponent = message ? <p>{message}</p> : null;

    return (
        <div className={classNames('PopupEmptyContent', className)}>
            {messageComponent}
            <Spinner show={showSpinner} />
            {children}
        </div>
    );
};

PopupEmptyContent.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string,
    showSpinner: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default PopupEmptyContent;
